import {
	isRejectedWithValue,
	type Middleware,
	type MiddlewareAPI
} from '@reduxjs/toolkit'
import { helpersFunc } from 'config/helpers'
import { notificationUtils } from 'features/notifications'
import { subscriptionUtils } from 'features/subscription'

const catchNotification = (action: () => Promise<unknown>) =>
	action().catch(notifyError)

function getMessage(error: Error) {
	switch (error.name) {
		case 'BadGatewayError':
		case 'RequestTimedOutError':
			return 'Bad network or service is temporarily unavailable. Please, try again later.'
		case 'OldExtensionError':
			return 'Please download new extension version'

		default:
			return error.message ? error.message : error.name
	}
}

function notifyError(error: unknown, isError = true, duration = 5000) {
	let text = ''
	if (error instanceof Error) {
		if (subscriptionUtils.shouldUpgrade(error)) {
			return
		}

		text = getMessage(error)
		helpersFunc.logEnjectServicePromise(error)
	}

	notificationUtils.show(text, isError, duration)
}

const rtkQueryErrorLogger: Middleware =
	(_: MiddlewareAPI) => next => action => {
		// RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
		if (isRejectedWithValue(action)) {
			notifyError(action.payload)
		}

		return next(action)
	}

export { catchNotification, notifyError, rtkQueryErrorLogger }
